export const generateStrongPassword = () => {
  const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lower = 'abcdefghijklmnopqrstuvwxyz';
  const numbers = '0123456789';
  const symbols = '!@#$%&()_+-=[]|<>?';
  const all = upper + lower + numbers + symbols;

  let pwd = '';
  // Ensure at least 1 upper, 2 numbers, 1 symbol and rest random up to 8 chars
  pwd += upper[Math.floor(Math.random() * upper.length)];
  pwd += numbers[Math.floor(Math.random() * numbers.length)];
  pwd += numbers[Math.floor(Math.random() * numbers.length)];
  pwd += symbols[Math.floor(Math.random() * symbols.length)];

  while (pwd.length < 8) {
    pwd += all[Math.floor(Math.random() * all.length)];
  }

  pwd = pwd.split('').sort(() => 0.5 - Math.random()).join('');
  return pwd.slice(0, 8); // ensure length 8
};

export const isPasswordStrong = (pwd) => {
  return (
    pwd.length >= 8 &&
    /[A-Z]/.test(pwd) &&
    /[0-9].*[0-9]/.test(pwd) &&
    /[^A-Za-z0-9]/.test(pwd)
  );
};
